import apiClient from "../core/apiClient";
import { ConfirmedZipInputDTO, PreviewSaveSummaryDTO } from "../interfaces/DTO/mimshakDataFileUpload";

import { Mimshak } from "../interfaces/DTO/mislaka_xml_models";


const PENSION_ASSETS_API_URL = "/person/assets"

class PersonAssetsService {
  async uploadFile(file: File): Promise<PreviewSaveSummaryDTO> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post<Promise<PreviewSaveSummaryDTO>>(
      `${PENSION_ASSETS_API_URL}/upload`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  }

  async previewFileAndAddClients(file: File): Promise<PreviewSaveSummaryDTO> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post(
      `${PENSION_ASSETS_API_URL}/preview-and-add-clients`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data.preview_results;
  }

  async previewFileAndWithClients(file: File): Promise<PreviewSaveSummaryDTO> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post(
      `${PENSION_ASSETS_API_URL}/preview-and-add-clients`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  }

  async previewFileAndSaveAll(
    file: File,
    handlerCode?: string,
    confirmedReportDate?: Date,
    isPreAdvice?: boolean
    ): Promise<PreviewSaveSummaryDTO> {
    const formData = new FormData();
    formData.append("file", file);

    if (isPreAdvice) {
        formData.append("is_pre_advice", "true");
    }

    if (handlerCode && confirmedReportDate) {
        const confirmedData = {
        handler_code: handlerCode,
        report_date: confirmedReportDate.toISOString(),
        };
        // שולחים את זה כ־string רגיל
        formData.append("confirmed_data", JSON.stringify(confirmedData));
    }

    const response = await apiClient.post(
        `${PENSION_ASSETS_API_URL}/preview-and-save-all`,
        formData,
        {
        headers: { "Content-Type": "multipart/form-data" },
        }
    );

    return response.data;
    }


  async previewFile(file: File): Promise<PreviewSaveSummaryDTO> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post<PreviewSaveSummaryDTO>(
      `${PENSION_ASSETS_API_URL}/preview`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  }

  async fetchMimshakData(filename: string): Promise<Mimshak[]> {
    const response = await apiClient.get<Mimshak[]>(`${PENSION_ASSETS_API_URL}/mimshak`, {
      params: { filename },
    });
    return response.data;
  }
  
}



export const personAssetsService = new PersonAssetsService();